import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from "recharts";

const eur = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(n ?? 0);

// Apoyo visual de la rejilla: gráfico de la caja proyectada mes a mes
// (escenario medio). El detalle numérico vive ahora en la propia rejilla.
export default function BudgetResults({ computed }) {
  const scenario = computed?.scenarios?.medium;
  if (!scenario || !scenario.months?.length) return null;

  const chartData = scenario.months.map((m) => ({
    month: m.month,
    caja: m.cash ?? null,
  }));

  return (
    <div className="border rounded-lg p-4 bg-white">
      <div className="text-sm font-semibold mb-2">En el banco mes a mes</div>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" fontSize={11} />
          <YAxis fontSize={11} />
          <Tooltip formatter={(v) => eur(v)} />
          <Line type="monotone" dataKey="caja" stroke="#2563eb" dot={false} strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
      {scenario.min_cash?.negative && (
        <p className="text-red-600 text-sm mt-2">
          ⚠️ La caja cae por debajo de cero en {scenario.min_cash.month} ({eur(scenario.min_cash.value)}).
        </p>
      )}
    </div>
  );
}
